export enum PaymentStatusEnum {
  Pending = 'pending',
  Failed = 'failed',
  Rejected = 'rejected',
  Success = 'success'
}
